module.exports = __webpack_public_path__ + "img/unsuke_dango.6fa6116d.jpg";